import { render, staticRenderFns } from "./NutritionAnalysis.vue?vue&type=template&id=61d42376&scoped=true"
import script from "./NutritionAnalysis.vue?vue&type=script&lang=js"
export * from "./NutritionAnalysis.vue?vue&type=script&lang=js"
import style0 from "./NutritionAnalysis.vue?vue&type=style&index=0&id=61d42376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d42376",
  null
  
)

export default component.exports